
import { Capacitor } from "@capacitor/core";

const platform = Capacitor.getPlatform();

// Production backend origin.
// API calls already contain /api, for example:
// /api/user/create
const PROD_API = "https://ecommerceproduct.continuumdigital.ca";

// Local development backend.
const LOCAL_API = "http://127.0.0.1:8081";

// Explicit environment variable takes priority.
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  (process.env.NODE_ENV === "production" ? PROD_API : LOCAL_API);

console.log("Capacitor platform:", platform);
console.log("NODE_ENV:", process.env.NODE_ENV);
console.log("API_BASE_URL:", API_BASE_URL);

